import { Component, Inject, OnInit } from '@angular/core';
import { MainService } from '../../service/main.service';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApiUrls } from '../../apiRouts';
import { environment } from '../../../environments/environment';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-activist-member-list',
  templateUrl: './activist-member-list.component.html',
  styleUrl: './activist-member-list.component.scss'
})
export class ActivistMemberListComponent implements OnInit {
  baseUrl = environment.imageURL;
  commitData: any = [];
  originalCommitData: any = [];
  user_type_id: any;
  sub2 = new Subscription;
  selectedTabIndex: number = 0;
  year: any;
  selectedYear = new Date().getFullYear();
  tabChangeId: any;
  currentYear: any;
  commitDataLength: any;

  constructor(
    private mainService: MainService,
    private _bottomSheet: MatBottomSheet
  ) {
    this.selectedYear = new Date().getFullYear();
    this.sub2 = this.mainService.sendFilterData().subscribe(res => {
      this.commitData = this.commitData.filter((user: any) => {

        const bloodGroupMatch = !res.blood_group || user.blood_group.toLowerCase() === res.blood_group.toLowerCase();
        const villageNameMatch = !res.village_name || user.village_name.toLowerCase().includes(res.village_name.toLowerCase());

        return bloodGroupMatch && villageNameMatch;
      });

    })
  }

  ngOnInit() {
    this.onTabChanged(0);
    this.getYear();
  }

  getCommitMember() {
    this.onTabChanged(this.selectedTabIndex)
  }

  getYear() {
    this.mainService.getApi(ApiUrls.yearList).subscribe((res: any) => {
      if (res.status == 1) {
        this.year = res.committee_year;
        this.currentYear = new Date().getFullYear();
        this.selectedYear = this.year.filter((a: any) => a.years == this.currentYear)[0].years;
      }
    });
  }

  selectedYearWiseCommittee(type: any, selectedYear: any) {
    this.mainService.getApi(ApiUrls.selectedYearWiseCommitteeList + Number(type) + '/' + selectedYear).subscribe((res: any) => {
      if (res.status == 1) {
        this.commitData = res.user;
        this.commitDataLength = this.commitData.length;
        this.originalCommitData = res.user;
      }
    });
  }

  onYearChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedYear = Number(selectElement.value);
    this.selectedYearWiseCommittee(this.tabChangeId, this.selectedYear);
  }

  openBottomSheet(): void {
    this._bottomSheet.open(FilterMemberForm, {
      data: this.commitData,
    });
  }

  searchMember(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.commitData = [...this.originalCommitData];
      return;
    }
    this.commitData = this.originalCommitData.filter((data: any) => {
      return data.name.toLowerCase().includes(filterValue) ||
        data.contact_no.includes(filterValue);
    });
    this.commitDataLength = this.commitData.length;
  }

  getCommitList(type: any) {
    this.mainService.getApi(ApiUrls.selectByTypeId + Number(type)).subscribe((res: any) => {
      if (res.status == 1) {
        this.commitData = res.user;
        this.commitDataLength = this.commitData.length;
        this.originalCommitData = res.user;
      }
    });
  }

  onTabChanged(event: number) {
    this.tabChangeId = event + 2;
    // this.getCommitList(this.tabChangeId);
    this.selectedYearWiseCommittee(this.tabChangeId, this.selectedYear);
  }
}


@Component({
  selector: 'app-filter-member',
  templateUrl: 'filter-member.component.html',
  standalone: true,
  imports: [MatListModule, CommonModule, SharedModule],
})
export class FilterMemberForm {
  villageListAll: any = [];
  filter_memberForm: FormGroup;
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<FilterMemberForm>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private mainService: MainService,
    private fb: FormBuilder
  ) {
    this.filter_memberForm = this.fb.group({
      blood_group: [''],
      village_name: [''],
      contact_no: [''],
    })

    this.getVillageList();
  }

  getVillageList() {
    this.mainService.getApi(ApiUrls.getAllVillageList).subscribe((res: any) => {
      this.villageListAll = res.village;
    });
  }

  submit() {
    let data = {
      blood_group: this.filter_memberForm.value.blood_group,
      village_name: this.filter_memberForm.value.village_name,
      contact_no: this.filter_memberForm.value.contact_no,
    }
    this.mainService.getFilterData(data);
    this._bottomSheetRef.dismiss();
  }

}
